import { getAPIEndpoint } from "./Utils"
const REACT_SP_API_URL = `${getAPIEndpoint()}/api/service-portal`
const REACT_PORTAL_API_URL = (env) => `https://${env === "prod" ? "portalone" : "stgportalone"}.processonepayments.com`
const REACT_MA_API_URL = `${getAPIEndpoint()}/api/my-account`
const REACT_MAIN_API_URL = `${getAPIEndpoint()}/api/main`
const REACT_APP_API_URL = `${getAPIEndpoint()}/api/app`
const REACT_APP_GW_API = 'https://cure-uat.mu-1-us-west-2.guidewire.net/coreapi/v5'
// const REACT_APP_GW_API = 'https://cure-prod.xi-1-us-west-2.guidewire.net/coreapi/v5'
const PORTAL_ONE_API_URL =
  "https://stgportalone.processonepayments.com/Api/Api";

export const driverInfoEndpoint = {
  getAddress: {
    method: "POST",
    url: `${REACT_SP_API_URL}/GetAddress`,
  },

  getAddressEndorsementRequest: {
    method: "POST",
    url: `${REACT_SP_API_URL}/GetAddressEndorsementRequest`,
  },


  getDrivers: {
    method: "POST",
    url: `${REACT_SP_API_URL}/GetDrivers`,
  },

  getTodaysDate: {
    method: "POST",
    url: `${REACT_SP_API_URL}/GetTodaysDate`,
  },

  getDriversEndorsementRequest: {
    method: "POST",
    url: `${REACT_SP_API_URL}/GetDriversEndorsementRequest`,
  },


  getVehicles: {
    method: "POST",
    url: `${REACT_SP_API_URL}/GetVehicles`,
  },

  getVehiclesEndorsementRequest: {
    method: "POST",
    url: `${REACT_SP_API_URL}/GetVehiclesEndorsementRequest`,
  },

  getEffectiveDate: {
    method: "POST",
    url: `${REACT_SP_API_URL}/GetEffectiveDate`,
  },

  validateAddress: {
    method: "POST",
    url: `${REACT_MA_API_URL}/ValidateAddress`,
  },

  getValidAddress: {
    method: "POST",
    url: `${REACT_MA_API_URL}/getValidAddress`,
  },

  getStateFromZip: {
    method: "POST",
    url: `${REACT_MA_API_URL}/GetStateFromZip`,
  }
};

export const addressChangeEndpoint = {
  pushMain: {
    method: "POST",
    url: `${REACT_SP_API_URL}/HandleChangeRequestMain`,
  },

  pushVehicle: {
    method: "POST",
    url: `${REACT_SP_API_URL}/HandleChangeRequestVehicle`,
  },

  pushPerson: {
    method: "POST",
    url: `${REACT_SP_API_URL}/HandleChangeRequestPerson`,
  },

  getPendingPolicyChanges: {
    method: "POST",
    url: `${REACT_SP_API_URL}/GetPendingPolicyChanges`
  }
};

export const policyChangeEndpoint = {
  submitChangeRequest: {
    method: "POST",
    url: `${REACT_SP_API_URL}/HandleChangeRequestClass`
  },

  submitEndorsementRequest: {
    method: "POST",
    url: `${REACT_SP_API_URL}/HandleEndorsementClass`
  },

  checkEndorsementStatus: {
    method: "POST",
    url: `${REACT_SP_API_URL}/CheckEndorsementStatus`
  },
  
  checkCodes: {
    method: "POST",
    url: `${REACT_SP_API_URL}/HandleChangeRequestCheckCodes`,
  },

  twilioInitialization: {
    method: "POST",
    url: `${REACT_APP_API_URL}/TwilioInitialization`,
  },
};

export const vehicleChangeEndpoint = {

  getLeasingList: {
    method: 'POST',
    url: `${REACT_SP_API_URL}/getLeasingList`
  },

  getFinanceCompanyList: {
    method: 'POST',
    url: `${REACT_SP_API_URL}/getFinanceCompanyList`
  },

  getFinanceLeasedCompaniesGWList: {
    method: 'GET',
    url: `${REACT_SP_API_URL}/GetCompaniesListGW`
  },

  checkPendingVIN: {
    method: 'POST',
    url: `${REACT_SP_API_URL}/CheckPendingVIN`
  },

  vinLookup: {
    method: 'POST',
    url: `${REACT_SP_API_URL}/VinLookup`
  },

  getDropdownOptions: {
    method: 'POST',
    url: `${REACT_SP_API_URL}/GetNewVehicleDropdownAnswers`
  }
}


export const loginEndpoint = {
  verify: {
    method: "POST",
    url: `${REACT_MA_API_URL}/VerifyLoginGW`,
  },

  verifyUser: {
    method: "POST",
    url: `${REACT_MA_API_URL}/VerifyLogin`,
  },

  verifyQS: {
    method: "POST",
    url: `${REACT_MA_API_URL}/LoadByPhoneAndZip`,
  },

  externalLogin: {
    method: "POST",
    url: `${REACT_MA_API_URL}/LoadByExternalToken`,
  },

  registerAccount: {
    method: "POST",
    url: `${REACT_MA_API_URL}/RegisterAccount`,
  },

  retrievePolicyUser: {
    method: "POST",
    url: `${REACT_MA_API_URL}/RetrievePolicyUser`,
  },

  resetPassword: {
    method: "POST",
    url: `${REACT_MA_API_URL}/SendTempPassword`,
  },

  getSecurityQuestions: {
    method: "POST",
    url: `${REACT_MA_API_URL}/GetSecurityQuestions`,
  },

  checkSecurityQuestions: {
    method: "POST",
    // url: `http://localhost:57761/api/my-account/CheckSecurityQuestions`
    url: `${REACT_MA_API_URL}/CheckSecurityQuestions`,
  },

  changeSecurityQuestions: {
    method: "POST",
    url: `${REACT_MA_API_URL}/ChangeSecurityQuestions`,
  },

  updateEmail: {
    method: "POST",
    url: `${REACT_MA_API_URL}/UpdateEmail`,
  },

  updateUsername: {
    method: "POST",
    url: `${REACT_MA_API_URL}/UpdateUsername`,
  },

  updatePassword: {
    method: "POST",
    url: `${REACT_MA_API_URL}/UpdatePassword`,
  },

  authenticateODS: {
    method: "POST",
    url: `${REACT_MA_API_URL}/AuthenticateODS`,
  },

  setPaperlessEmail: {
    method: "POST",
    url: `${REACT_MA_API_URL}/SetPaperlessEmail`,
  },

  loadByPolicyNumber: {
    method: "POST",
    url: `${REACT_MA_API_URL}/LoadByPolicyNumber`,
  },
  GetEnvironmentSettings: {
    method: "POST",
    url: `${REACT_MA_API_URL}/GetEnvironmentSettings`,
  },
};

export const renewalQuestionnaireEndpoint = {
  saveRenewalQuestionnaire: {
    method: "POST",
    url: `${REACT_MA_API_URL}/SaveRenewalQuestionnaire`,
  },
  submitRenewalQuestionnaire: {
    method: "POST",
    url: `${REACT_MA_API_URL}/SubmitRenewalQuestionnaire`,
  },
  fetchRenewalQuestionnaire: {
    method: "POST",
    url: `${REACT_MA_API_URL}/FetchRenewalQuestionnaireData`,
  }
};

export const portalOne = {
  portalOneAuthKey: (env) =>
    env === "prod"
      ? "F605DF6A-5707-4A00-8A1E-0FE743EAD76B"
      : "D2D344B8-8F34-4F95-9A81-976E8195BBFC",
  authKey: (env) =>
    env === "prod"
      ? "f8e7ef9c-e029-44f9-9e29-41e83cc50a7e"
      : "b0cffc04-1846-4ddb-bb60-46d6a0bd53a9",

  getCustomerId: {
    method: "POST",
    url: (env) => `${REACT_PORTAL_API_URL(env)}/Api/Api/Customer/CreateAccount`,
  },

  getPaymentMethod: {
    method: "POST",
    url: (env) => `${REACT_PORTAL_API_URL(env)}/Api/Api/PaymentMethod/Get`,
  },

  enrollAutoPay: {
    method: "POST",
    url: (env) =>
      `${REACT_PORTAL_API_URL(env)}/InstallmentsOne/api/InstallmentPlan/Enroll`,
  },

  checkAutoPay: {
    method: "POST",
    url: (env) =>
      `${REACT_PORTAL_API_URL(env)}/InstallmentsOne/api/InstallmentPlan/GetPaymentMethodInstallmentsInfoByToken`,
  },

  getActiveInstallmentPlan: {
    method: "POST",
    url: (env) =>
      `${REACT_PORTAL_API_URL(env)}/InstallmentsOne/api/InstallmentPlan/GetActiveInstallmentPlanByPolicyRefNumber`,
  },

  // checkPBTStatus: {
  //   method: "POST",
  //   url: (env) =>
  //     `${REACT_PORTAL_API_URL(env)}/Communication/api/Subscriptions/GetSubscriptionDetails`,
  // },
  
  checkPBTStatus: {
    method: "POST",
    url: `${REACT_MA_API_URL}/CheckPBTStatus`,
  },
};

export const paymentEndpoint = {
  updateOneIncTokens: {
    method: 'POST',
    url: `${REACT_MAIN_API_URL}/UpdateOneIncTokens`
  },

  getPaymentInfo: {
    method: 'POST',
    url: `${REACT_MA_API_URL}/GetPaymentInfo`,
    // query: 'PaymentCenter.sql',
  },
  getUseGenesysWebMessaging: {
    method: 'GET',
    url: `${REACT_MAIN_API_URL}/GetUseGenesysWebMessaging`
  },
  getLastPayment: {
    method: "POST",
    url: `${REACT_APP_API_URL}/RunQuery`,
    query: "PaymentCenterLast.sql",
  },

  getPaymentHistory: {
    method: 'POST',
    url: `${REACT_MA_API_URL}/GetPaymentHistory`,
  },

  getPaperlessBillHistory: {
    method: "POST",
    url: `${REACT_APP_API_URL}/RunQuery`,
    query: "GetPaperlessBillHistory.sql",
  },

  getInstallmentBill: {
    method: "POST",
    url: `${REACT_MA_API_URL}/GetInstallmentBill`,
  },

  registerForBilling: {
    method: "POST",
    url: `${REACT_MA_API_URL}/RegisterForBilling`,
  },

  getPaymentPdf: {
    method: "POST",
    url: `${REACT_APP_API_URL}/GetPdf`,
    endpoint: `https://{{GW_DOMAIN}}.guidewire.net/coreapi/v5/policies/{{systemId}}/documents/{{id}}/content`,
  },

  getAllPolicyDocs: {
    method: "POST",
    url: `${REACT_APP_API_URL}/RunQuery`,
    query: "GetAllPolicyDocs.sql",
  },

  getDocuments: {
    method: "POST",
    url: `${REACT_MA_API_URL}/GetDocuments`,
  },

  getDocument: {
    method: "POST",
    url: `${REACT_MA_API_URL}/DownloadDocument`,
  },

  GetArchive: {
    method: "POST",
    url: `${REACT_MA_API_URL}/GetArchive`,
  },

  GetAutoPayStatus: {
    method: "POST",
    url: `${REACT_MA_API_URL}/GetAutoPayStatus`,
  },

  GetDefaultPaymentStatus: {
    method: "POST",
    url: `${REACT_MA_API_URL}/GetDefaultPaymentStatus`,
  },
};

export const idCardEndpoint = {
  getIdCard: {
    method: "POST",
    url: `${REACT_MA_API_URL}/GetIdCards`,
  },
  sendIdCardEmail: {
    method: "POST",
    url: `${REACT_MA_API_URL}/SendIdCardEmail`,
  },
  getVehicleInfo: {
    method: "POST",
    url: `${REACT_MA_API_URL}/GetVehicleInfo`,
  },

  getRenewalQuestionnaires: {
    method: "POST",
    url: `${REACT_MA_API_URL}/GetRenewalQuestionnaires`,
  },

  getRenewalQuestionnairePDF:{
    method: "POST",
    url: `${REACT_MA_API_URL}/getRenewalQuestionnairePDF`,
  },

  getPolicyDocumentsByState: {
    method: "POST",
    url: `${REACT_MA_API_URL}/GetPolicyDocumentsByState`,
  },

  getPolicyDocumentsByDocID: {
    method: "POST",
    url: `${REACT_MA_API_URL}/GetPolicyDocumentsByDocID`,
  },

  getTempIDCard: {
    method: "POST",
    url: `${REACT_MA_API_URL}/DownloadIDCard`,
  },
  
  sendTempIDCard: {
    method: "POST",
    url: `${REACT_MA_API_URL}/EmailTempIDCard`
  }
};

export const websiteMaintenanceEndpoint = {
  status: {
    method: 'POST',
    url: `${REACT_MAIN_API_URL}/CheckWebsiteMaintenance`
  },
  message: {
    method: 'POST',
    url: `${REACT_MAIN_API_URL}/GetWebsiteMaintenanceMessage`
  }
}

export const FNOLEndpoint = {
  sendFNOLEmail: {
    method: 'POST',
    url: `${REACT_MAIN_API_URL}/SendFNOLEmail`
  },
  sendFNOLData: {
    method: 'POST',
    url: `${REACT_MA_API_URL}/SendFNOLDataMyAccount`
  },
  getFNOLReport: {
    method: 'GET',
    url: `${REACT_MAIN_API_URL}/GetFNOLReport`
  }
}